import React from 'react';
import './MyStyles/style.css';
import './MyStyles/responsive.css';

export const Banner = () => {
    return (
        <div>
            {/*<div className="contentTop flex">*/}
            {/*    <div className="width-top-left">*/}
            {/*        <h2 className="text-yellow">Friends & Family special</h2>*/}
            {/*        <h4 className="sub-head">One Subscription. Many OTTs. Multiple Devices.</h4>*/}
            {/*    </div>*/}
            {/*    <div className="width-top-right">*/}
            {/*        <img className="img-banner-size" src='./Images/watcho-banner.png' height="auto" width="fit-content" alt="watcho_banner" />*/}
            {/*    </div>*/}
            {/*</div>*/}
            <section>

                    <div id="myCarousel" className="carousel slide" data-ride="carousel">
                        {/*<!-- Indicators -->*/}
                        {/*<ol className="carousel-indicators">*/}
                        {/*    <li data-target="#myCarousel" data-slide-to="0" className="active"></li>*/}
                        {/*    */}{/*<li data-target="#myCarousel" data-slide-to="1"></li>*/}
                        {/*    */}{/*<li data-target="#myCarousel" data-slide-to="2"></li>*/}
                        {/*</ol> */}

                        {/*<!-- Wrapper for slides -->*/}
                        <div className="carousel-inner">
                            <div className="item active">
                                <div className="banner">
                                    <div className="banner-overlay"></div>
                                    <div className="container banner-content">
                                        <div className="row align-items-center">
                                            <div className="col-lg-7">
                                                <div className="offer-text">GIFT YOUR LOVED ONES A PACK FULL OF OTT FUN!</div>
                                                <div className="discount-text">Save 30% on 10 Vouchers & 50% on 10+ Vouchers</div>
                                                <div className="device-container">
                                                    <div className="text-center">
                                                        <span className="watch-on-any">Watch on any device</span>
                                                    </div>
                                                    <div className="device-icons d-flex">
                                                        <div className="honoe-me">
                                                            <img src="./Images/TV.png" alt="TV Icon"/>
                                                            <p>TV</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Laptop.png" alt="Desktop Icon"/>
                                                            <p>Desktop</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Mobile.png" alt="Mobile Icon"/>
                                                            <p>Mobile</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Laptop-1.png" alt="Laptop Icon"/>
                                                            <p>Laptop</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Tablet.png" alt="Tablet Icon"/>
                                                            <p>Tablet</p>
                                                        </div>
                                                    </div>
                                            </div>

                                            </div>
                                            <div className="col-lg-5 text-center">
                                                <div className="banner-image banner-image-bottom-stretch">
                                                    <img 
                                                        src="./Images/Asia-cup-1-372-x-240.jpg" 
                                                        alt="Banner1" 
                                                        className="stretch-bottom-img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>

                            {/*<div className="item">*/}
                            {/*    <div className="banner">*/}
                            {/*        <div className="banner-overlay"></div>*/}
                            {/*        <div className="container banner-content">*/}
                            {/*            <div className="row align-items-center">*/}
                            {/*                <div className="col-lg-7">*/}
                            {/*                <div className="offer-text">GIFT YOUR LOVED ONES A PACK FULL OF OTT FUN!</div>*/}
                            {/*                    <div className="discount-text">Save 30% on 10 Vouchers & 50% on 10+ Vouchers</div>*/}
                            {/*                    <div className="device-container">*/}
                            {/*                        <div className="text-center">*/}
                            {/*                            <span className="watch-on-any">Watch on any device</span>*/}
                            {/*                        </div>*/}
                            {/*                        <div className="device-icons d-flex">*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/TV.png" alt="TV Icon"/>*/}
                            {/*                                    <p>TV</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Laptop.png" alt="Desktop Icon"/>*/}
                            {/*                                    <p>Desktop</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Mobile.png" alt="Mobile Icon"/>*/}
                            {/*                                    <p>Mobile</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Laptop-1.png" alt="Laptop Icon"/>*/}
                            {/*                                    <p>Laptop</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Tablet.png" alt="Tablet Icon"/>*/}
                            {/*                                    <p>Tablet</p>*/}
                            {/*                            </div>*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}

                            {/*                </div>*/}
                            {/*                <div className="col-lg-5 text-center">*/}
                            {/*                    <div className="banner-image">*/}
                            {/*                    <img src="./Images/Banner1-472x327.png" alt="Banner2"/> */}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {/*<div className="item">*/}
                            {/*    <div className="banner">*/}
                            {/*        <div className="banner-overlay"></div>*/}
                            {/*        <div className="container banner-content">*/}
                            {/*            <div className="row align-items-center">*/}
                            {/*                <div className="col-lg-7">*/}
                            {/*                <div className="offer-text">GIFT YOUR LOVED ONES A PACK FULL OF OTT FUN!</div>*/}
                            {/*                    <div className="discount-text">Save 30% on 10 Vouchers & 50% on 10+ Vouchers</div>*/}
                            {/*                    <div className="device-container">*/}
                            {/*                        <div className="text-center">*/}
                            {/*                            <span className="watch-on-any">Watch on any device</span>*/}
                            {/*                        </div>*/}
                            {/*                        <div className="device-icons d-flex">*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/TV.png" alt="TV Icon"/>*/}
                            {/*                                    <p>TV</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Laptop.png" alt="Desktop Icon"/>*/}
                            {/*                                    <p>Desktop</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Mobile.png" alt="Mobile Icon"/>*/}
                            {/*                                    <p>Mobile</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Laptop-1.png" alt="Laptop Icon"/>*/}
                            {/*                                    <p>Laptop</p>*/}
                            {/*                            </div>*/}
                            {/*                            <div className="honoe-me">*/}
                            {/*                                <img src="./Images/Tablet.png" alt="Tablet Icon"/>*/}
                            {/*                                    <p>Tablet</p>*/}
                            {/*                            </div>*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}

                            {/*                </div>*/}
                            {/*                <div className="col-lg-5 text-center">*/}
                            {/*                    <div className="banner-image">*/}
                            {/*                    <img src="./Images/Banner1-472x327.png" alt="Banner"/> */}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*</div> */}

                            {/*<!-- Left and right controls -->*/}
                            {/*<a className="left carousel-control" href="#myCarousel" data-slide="prev">*/}
                            {/*    <span className="glyphicon glyphicon-chevron-left"></span>*/}
                            {/*    <span className="sr-only">Previous</span>*/}
                            {/*</a>*/}
                            {/*<a className="right carousel-control" href="#myCarousel" data-slide="next">*/}
                            {/*    <span className="glyphicon glyphicon-chevron-right"></span>*/}
                            {/*    <span className="sr-only">Next</span>*/}
                            {/*</a>*/}
                        </div>
                    </div>
            </section>
        </div>
    );
}